import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { SolidButton } from "components/buttons/SolidButton";

const MspSuspended = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        pt: 8,
        pb: 8,
      }}
    >
      <Box sx={{ maxWidth: 620 }}>
        <Typography sx={{ fontSize: 20, fontWeight: 700, color: "#111827" }}>
          This MSP is Suspended
        </Typography>

        <Typography sx={{ mt: 3.5, fontSize: 14, lineHeight: 1.55, color: "#111827" }}>
          This MSP has run out of credits and its management license has passed the grace period. The console stays locked until the license is settled.
        </Typography>

        <Typography sx={{ mt: 3.5, fontSize: 14, lineHeight: 1.55, color: "#111827" }}>
          Managed organizations are unaffected — their networks keep forwarding traffic. Only console access is withheld.
        </Typography>

        <Typography sx={{ mt: 3.5, fontSize: 14, lineHeight: 1.55, color: "#111827" }}>
          License Management remains available to settle and reinstate this license. Access to the remaining MSP console functions returns automatically after reinstatement.
        </Typography>

        <Box sx={{ mt: 5, display: "flex", justifyContent: "center" }}>
          <SolidButton
            width='230px'
            height='32px'
            sx={{ whiteSpace: "nowrap" }}
          onClick={() => navigate("/msp/license")}
          >
            Go to License Management
          </SolidButton>
        </Box>
      </Box>
    </Box>
  );
};

export default MspSuspended;
